export const OPERATIONAL = "OPERATIONAL";
export const SCHEDULED_MAINTENANCE = "SCHEDULED_MAINTENANCE";
export const DEGRADED = "DEGRADED";
export const UNKNOWN = "UNKNOWN";
export const OFFLINE = "OFFLINE";
